import Serializable from "Serializable";
import GraphType from "GraphType";
import PeriodicityHelper from "PeriodicityHelper";

class RiPanelAiSettings extends Serializable {

    constructor() {
        super();
        this.zigzagIndicator = this.getDefaultZigzagIndicatorSettings();
        this.futureEvent = this.getDefaultFutureEventSettings();
    }

    onSeralisedInfoRecieved(serializedValue) {
        this.zigzagIndicator = serializedValue.zigzagIndicator ? serializedValue.zigzagIndicator : this.getDefaultZigzagIndicatorSettings();
        this.futureEvent = serializedValue.futureEvent ? serializedValue.futureEvent : this.getDefaultFutureEventSettings();
    }

    OnSeralisedInfoRecieved(info) {
        Object.assign(this, info);
    }

    getObjectMapKey() {
        return "RiPanelAiSettings";
    }

    getDataObject() {
        return {
            zigzagIndicator: this.zigzagIndicator,
            futureEvent: this.futureEvent
        };
    }

    getDefaultZigzagIndicatorSettings() {
        const z = new Serializable();
        z.isVisible = false;
        z.lineStyle = this.getDefaultLineStyle();
        z.swingSize = this.getDefaultSwingSize();
        return z;
    }

    getDefaultLineStyle() {
        const lineStyle = new Serializable();
        for (let periodicity in GraphType) {
            const majorPeriodicity = PeriodicityHelper.mapMajorPeriodicities(periodicity);

            switch (majorPeriodicity) {
                case GraphType.Daily:
                case GraphType.Weekly:
                case GraphType.Monthly:
                    lineStyle[majorPeriodicity] = new Serializable();
                    lineStyle[majorPeriodicity].color = "PFFFFFF000000";
                    lineStyle[majorPeriodicity].weight = 2;
                    break;
                default:
                    break;
            }
        }

        return lineStyle;
    }

    getDefaultSwingSize() {
        const swingSize = new Serializable();
        swingSize.Daily = 10;
        swingSize.Weekly = 15;
        swingSize.Monthly = 20;
        return swingSize;
    }

    getDefaultFutureEventSettings() {
        const futureEvent = new Serializable();
        futureEvent.isVisible = false;
        futureEvent.gutterSize = this.getDefaultGutterSize();
        futureEvent.useEpsRpsSettings = false;
        futureEvent.eventsAllowed = this.getDefaultEventsAllowed();
        return futureEvent;
    }

    getDefaultGutterSize() {
        const gutterSize = new Serializable();
        gutterSize.Daily = 2;
        gutterSize.Weekly = 4;
        gutterSize.Monthly = 2;
        return gutterSize;
    }

    getDefaultEventsAllowed() {
        const eventsAllowed = new Serializable();
        eventsAllowed.Critical = true;
        eventsAllowed.CompanyNews = true;
        eventsAllowed.ProductNews = true;
        eventsAllowed.Industry = true;
        eventsAllowed.GovernmentRegulations = true;
        return eventsAllowed;
    }
}

export default RiPanelAiSettings;